/**
 * Construction des balises <title> pour les pages dont le titre vient de la base
 * (articles, offres, réalisations, lieux).
 *
 * POURQUOI : Google tronque les titres autour de 60 caractères. Le suffixe de marque
 * « - Maison Eridia » coûte 16 caractères et faisait dépasser 178 des 205 articles
 * pré-rendus (audit du 23/08/2026), alors qu'AUCUN titre d'article ne dépasse 60
 * caractères tout seul : c'était le suffixe, et lui seul, qui provoquait la troncature.
 *
 * RÈGLE : on ajoute le suffixe de marque uniquement s'il tient dans la limite. Sinon
 * le titre éditorial passe en entier — mieux vaut perdre la marque que le mot-clé.
 */

export const SEO_TITLE_MAX = 60;

/**
 * @param base    titre éditorial (titre d'article, d'offre, de lieu…)
 * @param suffix  suffixe de marque, séparateur compris (ex. ' - Maison Eridia')
 */
export function withBrandSuffix(base: string, suffix = ' - Maison Eridia'): string {
  const title = (base ?? '').trim();
  if (!title) return suffix.replace(/^[\s\-|—]+/, '');
  return title.length + suffix.length <= SEO_TITLE_MAX ? `${title}${suffix}` : title;
}
